import type { Variant } from './FadeOutBall';

const FROM_TO_KEYFRAMES = `
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
`;

const TO_KEYFRAMES = `
@keyframes fadeToTransparent {
  to {
    opacity: 0;
  }
}
`;

export function constructSnippet(variant: Variant) {
  return variant === 'with-from' ? FROM_TO_KEYFRAMES : TO_KEYFRAMES;
}
